import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitohyderabadcab() {



  const cardData = {
    keyword: " Mumbai to Hyderabad Cabs ",


"headingDescription": "Royal Route Cab offers reliable Mumbai to Hyderabad cab services, providing safe, comfortable, and affordable long-distance travel for families, corporate travelers, students, and group journeys. The Mumbai to Hyderabad route is a major interstate travel corridor connecting Maharashtra and Telangana, and our professional drivers ensure a smooth, punctual, and stress-free road trip experience. We offer flexible travel options including one-way drops, round trips, and customized multi-day itineraries based on your travel needs. Our fleet includes economy sedans, premium sedans, SUVs, Innova, Ertiga, Innova Crysta, and Tempo Travellers suitable for all group sizes. With transparent pricing, 24/7 availability, and easy booking, Royal Route Cab is your trusted choice for Mumbai to Hyderabad cab services.",

"topPlaces": [
  {
    "title": "Charminar",
    "description": "Charminar is the most iconic landmark of Hyderabad, built in 1591 and known for its stunning Indo-Islamic architecture. It is surrounded by bustling markets like Laad Bazaar where visitors enjoy shopping for bangles, pearls, and traditional items. It is a must-visit destination for travelers arriving from Mumbai by cab, offering a vibrant mix of history, culture, and street life."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort is a historic fortress known for its massive stone walls, acoustic engineering, and rich history of the Qutb Shahi dynasty. Visitors can explore ancient gateways, royal chambers, and enjoy panoramic views of Hyderabad city, making it a popular sightseeing stop for road trip travelers."
  },
  {
    "title": "Hussain Sagar Lake",
    "description": "Hussain Sagar Lake is a beautiful man-made lake famous for the large Buddha statue located in the center. It is a peaceful spot for evening walks, boat rides, and scenic views of Hyderabad’s skyline, making it a relaxing stop after a long journey from Mumbai."
  },
  {
    "title": "Ramoji Film City",
    "description": "Ramoji Film City is one of the largest film studio complexes in the world and a top tourist attraction in Hyderabad. It offers film sets, theme parks, live shows, and entertainment zones, making it a perfect family destination for travelers coming from Mumbai by cab."
  },
  {
    "title": "Birla Mandir Hyderabad",
    "description": "Birla Mandir is a beautiful white marble temple situated on a hilltop overlooking Hyderabad city. It is dedicated to Lord Venkateswara and offers a peaceful spiritual atmosphere along with panoramic city views, making it a popular stop for pilgrims and tourists."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum is one of the largest museums in India, showcasing a vast collection of art, sculptures, manuscripts, and antiques from around the world. It is a must-visit cultural attraction for history lovers traveling from Mumbai."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace is a stunning royal palace of the Nizams of Hyderabad known for its elegant architecture, grand courtyards, and historical artifacts. It reflects the rich royal heritage of Hyderabad and is a key stop for heritage tourism."
  },
  {
    "title": "Shilparamam",
    "description": "Shilparamam is a cultural village showcasing traditional crafts, handlooms, and rural art forms of India. It offers live cultural performances, handicraft shopping, and food stalls, making it a vibrant cultural stop for visitors from Mumbai."
  },
  {
    "title": "Necklace Road",
    "description": "Necklace Road is a scenic boulevard around Hussain Sagar Lake known for its beautiful night views, parks, and recreational spaces. It is a popular relaxation spot for travelers after long-distance cab journeys."
  },
  {
    "title": "Laad Bazaar",
    "description": "Laad Bazaar is a famous traditional market near Charminar known for bangles, pearls, jewelry, and ethnic wear. It offers a colorful shopping experience and is a must-visit destination for tourists exploring Hyderabad."
  }
],






services: [
  {
    name: "Mumbai to Hyderabad Cab",
    description: "Mumbai to Hyderabad cab service offers a comfortable and reliable long-distance journey connecting two major cities. Ideal for business travelers, families, and tourists, this service ensures smooth highway travel with experienced drivers. Well-maintained vehicles provide comfort throughout the trip. It guarantees a safe and hassle-free journey."
  },
  {
    name: "Mumbai to Hyderabad Taxi",
    description: "Mumbai to Hyderabad taxi provides private and convenient travel for intercity journeys. This service includes door-to-door pickup and flexible travel schedules. Suitable for long-distance travel with comfort and safety. It ensures a smooth ride."
  },
  {
    name: "Mumbai to Hyderabad Cab Service",
    description: "Mumbai to Hyderabad cab service offers professional travel solutions with multiple vehicle options. This service is ideal for business trips, family travel, and group journeys. Clean vehicles and trained drivers enhance comfort. It ensures a reliable travel experience."
  },
  {
    name: "Mumbai to Hyderabad Taxi Service",
    description: "Mumbai to Hyderabad taxi service ensures dependable transportation with comfortable vehicles and professional chauffeurs. This service is ideal for long-distance travel. Flexible booking options enhance convenience. It guarantees a pleasant journey."
  },
  {
    name: "Cab from Mumbai to Hyderabad",
    description: "Cab from Mumbai to Hyderabad offers a convenient way to travel between cities with complete comfort. This service is ideal for those preferring road travel over flights or trains. Professional drivers ensure safe journeys. It ensures a stress-free experience."
  },
  {
    name: "Taxi from Mumbai to Hyderabad",
    description: "Taxi from Mumbai to Hyderabad provides reliable long-distance travel for individuals and groups. This service ensures smooth highway travel with experienced drivers. Comfortable seating enhances the journey. It guarantees a dependable travel option."
  },
  {
    name: "Mumbai to Hyderabad Cab Booking",
    description: "Mumbai to Hyderabad cab booking allows customers to reserve their ride easily with flexible options. Travelers can select vehicle type, pickup location, and timing. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Mumbai to Hyderabad Taxi Booking Online",
    description: "Mumbai to Hyderabad taxi booking online provides a quick and convenient way to plan your journey. Customers can compare vehicles and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Mumbai to Hyderabad Cab Price",
    description: "Mumbai to Hyderabad cab price varies based on vehicle type, distance, and trip duration. Transparent pricing ensures no hidden charges. Customers can choose from budget and premium options. It helps in planning travel expenses efficiently."
  },
  {
    name: "Mumbai to Hyderabad Taxi Fare",
    description: "Mumbai to Hyderabad taxi fare is designed to be competitive for long-distance travel. Fare depends on route and vehicle selection. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Hyderabad One Way Cab",
    description: "Mumbai to Hyderabad one way cab offers cost-effective travel without return charges. This service is ideal for single-side journeys. Flexible pickup options enhance convenience. It ensures smooth and economical travel."
  },
  {
    name: "Mumbai to Hyderabad Round Trip Taxi",
    description: "Mumbai to Hyderabad round trip taxi provides complete travel solutions including return journeys. This service is ideal for business trips and vacations. Flexible schedules and comfortable vehicles enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Mumbai to Hyderabad Innova Cab",
    description: "Mumbai to Hyderabad Innova cab is perfect for families and groups seeking spacious and comfortable travel. Premium seating and smooth performance enhance long journeys. It ensures a comfortable intercity experience."
  },
  {
    name: "Mumbai to Hyderabad Ertiga Cab",
    description: "Mumbai to Hyderabad Ertiga cab offers affordable and spacious travel for small groups and families. Comfortable seating and good mileage make it ideal for long-distance journeys. It ensures a pleasant trip."
  },
  {
    name: "Mumbai to Hyderabad Sedan Cab",
    description: "Mumbai to Hyderabad sedan cab is ideal for individuals and small families seeking economical travel. Sedans offer smooth rides and comfort for long journeys. Professional drivers ensure safety. It ensures a relaxed journey."
  },
  {
    name: "Mumbai to Hyderabad SUV Taxi",
    description: "Mumbai to Hyderabad SUV taxi provides spacious and comfortable travel for groups. SUVs offer better performance and extra space for luggage. Suitable for long-distance journeys. It ensures a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Hyderabad Cab",
    description: "Cheap Mumbai to Hyderabad cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures economical travel."
  },
  {
    name: "Best Mumbai to Hyderabad Taxi Service",
    description: "Best Mumbai to Hyderabad taxi service ensures top-quality vehicles, professional drivers, and excellent customer support. This service focuses on comfort, safety, and punctuality. It guarantees a reliable and premium journey."
  }
],

tableData: [
  ["Mumbai to Hyderabad Cab", "Mumbai to Hyderabad Taxi"],
  ["Mumbai to Hyderabad Cab Service", "Mumbai to Hyderabad Taxi Service"],
  ["Cab from Mumbai to Hyderabad", "Taxi from Mumbai to Hyderabad"],
  ["Mumbai to Hyderabad Cab Booking", "Mumbai to Hyderabad Taxi Booking Online"],
  ["Mumbai to Hyderabad Cab Price", "Mumbai to Hyderabad Taxi Fare"],
  ["Mumbai to Hyderabad One Way Cab", "Mumbai to Hyderabad Round Trip Taxi"],
  ["Mumbai to Hyderabad Innova Cab", "Mumbai to Hyderabad Ertiga Cab"],
  ["Mumbai to Hyderabad Sedan Cab", "Mumbai to Hyderabad SUV Taxi"],
  ["Cheap Mumbai to Hyderabad Cab", "Best Mumbai to Hyderabad Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Hyderabad Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Hyderabad cab service, ideal for long-distance business trips and family travel."
  },
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in interstate travel, ensuring safe driving, proper navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day travel plans for Hyderabad trips."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Hyderabad cab service operates 24/7, allowing flexible departure anytime as per your schedule."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned for a comfortable long-distance journey."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for group travel."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Hyderabad cab bookings due to reliable service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Hyderabad cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Hyderabad for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Hyderabad?", answer: "The distance is approximately 700 to 750 km and takes around 12 to 15 hours depending on route and traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Hyderabad cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide interstate travel permits?", answer: "Yes, all required permits are arranged for smooth interstate travel." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for long-distance travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kiran Reddy",
    feedback: "The Mumbai to Hyderabad cab service with Royal Route Cabs was very smooth and well-managed. The long-distance journey felt safe and comfortable throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Sharma",
    feedback: "Excellent experience traveling from Mumbai to Hyderabad. The cab was clean, the driver was professional, and the entire trip was hassle-free and relaxing.",
    rating: 5
  }
];










  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Hyderabad Cabs",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-hyderabad-cab.jpg", // replace if needed
  "description": "Book Mumbai to Hyderabad cab service with Royal Route Cabs for safe, reliable, and comfortable long-distance travel. Available for one-way and round-trip journeys with sedan, SUV, Innova, and luxury cars. 24x7 intercity taxi service at affordable prices.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15", // per km approx starting (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-hyderabad-cabs"
  }
};







  return (
    <div>
<Helmet>
  <title>Mumbai to Hyderabad Cabs | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Hyderabad cab with Royal Route Cabs. Safe and affordable long-distance taxi service with sedan, SUV, Innova & luxury cars. 24x7 reliable intercity travel."
  />

  <meta
    name="keywords"
    content="mumbai to hyderabad cab, mumbai to hyderabad taxi, mumbai to hyderabad cab service, mumbai to hyderabad taxi service, cab from mumbai to hyderabad, taxi from mumbai to hyderabad, mumbai to hyderabad cab booking, mumbai to hyderabad taxi booking online, mumbai to hyderabad cab price, mumbai to hyderabad taxi fare, mumbai to hyderabad one way cab, mumbai to hyderabad round trip taxi, mumbai to hyderabad innova cab, mumbai to hyderabad ertiga cab, mumbai to hyderabad sedan cab, mumbai to hyderabad suv taxi, cheap mumbai to hyderabad cab, best mumbai to hyderabad taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/51.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitohyderabadcab;